/**
 * @date: 12/10/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */

import React from "react";
import './KeyValuePair.css';

export default function KeyValuePair(props) {
    const name = props.name || "";
    const value = props.value || "";
    const renderValue = props.renderValue;
    const display = props.display || 'block'; // inline || block
    const size = props.size || "m";
    const inlineCls = display === "inline" ? "keyValuePair-inline" : "";
    var sizeCls = `keyValuePair-${size}`;
    return (<div className={`keyValuePair ${inlineCls} ${sizeCls}`}>
        <span className='keyValuePair-key'>{name}</span>
        {renderValue && <span className='keyValuePair-value'>
            {renderValue()}
        </span>}
        {
            !renderValue && <span className='keyValuePair-value'>{value}</span>
        }

    </div> );
}
